<template>
    <ul class="shop-goods-list">
        <router-link
                tag="li"
                v-for="(item,index) in goodsList"
                :key="index"
                :to="{path:`/goods/detail/${item.id}`}">
            <el-image class="goods-img" :src="$common.imgPath(item.goodsLog)" :alt="item.goodsName" lazy fit="cover"></el-image>
            <p class="goods-desc" v-text="item.goodsDesc?item.goodsDesc:''"></p>
            <div class="price" v-if="goodsType==1">
                <div class="fl price-txt price-color"><span class="flag">¥</span>{{item.price}}</div>
                <!--<div class="fl num">已经出价<span class="price-color">3</span>次</div>-->
            </div>
            <div class="video-auth" v-if="goodsType==2">
                <div class="cell-item auth-img">
                    <!--<img src="../../assets/images/mrtx.png" alt="">-->
                    <el-image class="goods-img" :src="$common.imgPath(item.shop.shopImg)" :alt="item.shop.celebrityName" lazy fit="cover"></el-image>
                </div>
                <div class="cell-item auth-name">{{item.shop.shopName}}</div>
                <div class="cell-item like"><i class="el-icon-apple"></i>{{item.shop.shopName}}</div>
            </div>
        </router-link>


    </ul>
</template>
<script>
    export default {
        data(){
            return {
                id:1
            }
        },
        props:{
            goodsType: {
                type: Number,
                default: 1
            },
            goodsList:[Array]
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../assets/css/common';
    .shop-goods-list{
        padding:0 30px;
        overflow: hidden;
        li{
            cursor: pointer;
            width:275px;
            float: left;
            &+li{
                margin-left:13px;
            }
            &:nth-child(4n+1){margin-left:0}
            .goods-img{
                width:275px;
                height:320px;
                -webkit-border-radius: 10px;
                -moz-border-radius: 10px;
                border-radius: 10px;
                background-color: #f7f6f9;
            }
            .goods-desc{
                height: 50px;
                line-height: 25px;
                color: #3B3B3B;
                font-size: 16px;
                margin: 13px 10px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
            }
            .price{
                padding:0 12px 40px;
                overflow: hidden;
                .price-color{
                    color:#F94040;
                }
                .price-txt{
                    font-size:24px;
                    font-weight:600;
                    .flag{
                        font-size:12px;
                        font-weight:500;
                    }
                }
                .num{
                    font-size:15px;
                    padding-left:20px;
                    line-height:32px;
                }
            }
            .video-auth{
                padding-bottom:30px;
                display: table;
                width:100%;
                .cell-item{
                    display: table-cell;
                    vertical-align: middle;
                }
                .auth-img{
                    padding-left:12px;
                    width:50px;
                    height:50px;
                    img{
                        width:50px;
                        height:50px;
                        -webkit-border-radius: 50%;
                        -moz-border-radius: 50%;
                        border-radius: 50%;

                    }


                }
                .auth-name{
                    font-size:16px;
                    color:#333333;
                    padding-left:10px;
                }
                .like{
                    text-align: right;
                    color:#999999;
                    font-size:16px;
                    padding-right:12px;
                    i{
                        color:#a19ea2;
                        font-size:32px;
                    }
                }
            }
        }
    }
</style>